exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".route--active{font-weight:700;text-decoration:underline}", "", {"version":3,"sources":["/./src/components/Header/src/components/Header/Header.scss"],"names":[],"mappings":"AAAA,eACE,gBAAkB,yBACS,CAC5B","file":"Header.scss","sourcesContent":[".route--active {\r\n  font-weight: bold;\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&-minimize!./~/postcss-loader!./~/sass-loader?sourceMap!./src/components/Header/Header.scss
// module id = 372
// module chunks = 0